export default __webpack_public_path__ + "static/media/39_BottomRightSquares_Top.7926df53.mp4";